import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function AuthorizedRep() {
  return (
    <>
      <Helmet>
        <title>Authorized Representative - RMQ Digital</title>
        <meta name="description" content="Authorized representative contact information for RMQ HOLDINGS INC A2P 10DLC campaign registration and compliance inquiries." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Authorized Representative</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Official contact for A2P 10DLC registration and compliance matters</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Company Information
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '1rem' }}>
                Legal Business Name
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937', fontWeight: '600' }}>
                RMQ HOLDINGS INC
              </p>
            </div>

            <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '1rem' }}>
                Employer Identification Number (EIN)
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937', fontWeight: '600' }}>
                99-1828959
              </p>
            </div>

            <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '1rem' }}>
                Business Owner
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937', fontWeight: '600' }}>
                Moshe Qubrusi
              </p>
            </div>

            <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '1rem' }}>
                Business Address
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937', lineHeight: '1.6' }}>
                2022 East 9th Street<br />
                Brooklyn, NY 11223<br />
                United States
              </p>
            </div>
          </div>
        </div>

        <div style={{ background: 'white', border: '1px solid #e5e7eb', padding: '3rem', borderRadius: '12px', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Authorized Representative Contact
          </h2>
          
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                Name
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937' }}>
                Moshe Qubrusi
              </p>
            </div>

            <div style={{ marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                Title
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937' }}>
                Owner & Chief Executive Officer
              </p>
            </div>

            <div style={{ marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                Email
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937' }}>
                <a href="mailto:compliance@rmqdigital.com" style={{ color: '#6d28d9', textDecoration: 'none' }}>
                  compliance@rmqdigital.com
                </a>
              </p>
            </div>

            <div style={{ marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                Phone
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937' }}>
                <a href="tel:+17185551234" style={{ color: '#6d28d9', textDecoration: 'none' }}>
                  (718) 555-1234
                </a>
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                Business Hours
              </h3>
              <p style={{ fontSize: '1.1rem', color: '#1f2937', lineHeight: '1.8' }}>
                Monday - Friday: 9:00 AM - 6:00 PM EST<br />
                Saturday: 10:00 AM - 2:00 PM EST<br />
                Sunday: Closed
              </p>
            </div>
          </div>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '3rem', borderRadius: '12px', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1.5rem', textAlign: 'center' }}>
            A2P 10DLC Registration Authority
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', opacity: 0.95 }}>
            The authorized representative listed above has full authority to:
          </p>
          <ul style={{ fontSize: '1.1rem', lineHeight: '2', opacity: 0.95, paddingLeft: '2rem' }}>
            <li>Register and manage A2P 10DLC campaigns with The Campaign Registry (TCR)</li>
            <li>Submit brand and campaign information to wireless carriers</li>
            <li>Accept terms and conditions on behalf of RMQ HOLDINGS INC</li>
            <li>Respond to compliance inquiries from carriers and regulatory bodies</li>
            <li>Make binding decisions regarding SMS/MMS messaging programs</li>
            <li>Authorize use of company information for carrier vetting purposes</li>
          </ul>
        </div>

        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Verification & Compliance
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                IRS Verified
              </h3>
              <p style={{ color: '#6b7280' }}>
                EIN verified with IRS records
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                Business Registered
              </h3>
              <p style={{ color: '#6b7280' }}>
                Registered in New York State
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                TCPA Compliant
              </h3>
              <p style={{ color: '#6b7280' }}>
                Following all TCPA regulations
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                Carrier Approved
              </h3>
              <p style={{ color: '#6b7280' }}>
                Approved for A2P messaging
              </p>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', padding: '3rem 0' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
            Need to Contact Us?
          </h2>
          <p style={{ fontSize: '1.1rem', color: '#6b7280', marginBottom: '2rem' }}>
            For compliance inquiries, A2P registration questions, or general support
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/contact" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}>
              Contact Form
            </a>
            <a href="/support" style={{
              display: 'inline-block',
              background: 'white',
              color: '#6d28d9',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid #6d28d9',
              transition: 'all 0.3s ease'
            }}>
              Support Center
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
